<template>
  <div class="pendding-order">
    <div class="order-list" v-show="orderList.length">
      <list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="sku-details" v-for="(sku, index) in orderList" :key="index">
          <div class="service-ticket">
            <button class="service-number">服务单号：{{sku.serial_no}}</button>
            <span class="service-status">{{statusText(sku.status)}}</span>
          </div>
          <a
            href="javascript:;"
            class="jump-details"
            @click="goDetails(sku.serial_no)"
          >
            <div class="sku-img">
              <img v-lazy="sku.pic_url" />
            </div>
            <div class="sku-desc">
              <div class="sku-intro">
                <div class="sku-title">{{sku.name}}</div>
                <div class="sku-name-num">
                  <div class="sku-name">
                    <span>
                      <em
                        v-for="(attr, index) in sku.attr_list"
                        :key="index"
                      >{{attr.attr_value.value}}</em>
                    </span>
                  </div>
                  <div class="sku-num">数量: {{sku.number}}</div>
                </div>
                <div class="sku-platform">{{sku.platform_info.brand}}</div>
              </div>
              <div class="sku-functional-btn">
                <button
                  v-show="sku.status < 40"
                  class="withdraw-application"
                  @click.stop="withdrawApplication(sku.serial_no)"
                >取消申请</button>
              </div>
            </div>
          </a>
          <div class="status-tips" v-show="sku.status === 30">
            <span>商品需寄回，请填写寄回快递信息</span>
            <button @click="fillLogisticsInfoHandler(sku.serial_no)">填写信息</button>
          </div>
        </div>
      </list>
    </div>
    <no-data v-show="noData && !orderList.lnegth"></no-data>
    <dialogs
      v-model="dialog.show"
      :cancel-text="dialog.cancelText"
      @confrim-handler="confrimHandler"
      @cancel-handler="cancelHandler"
    >
      <p slot="msg">您确认要取消售后申请吗?</p>
    </dialogs>
    <fill-logistics-info
      ref="fillLogisticsInfo"
      :show="fillLogisticsInfo.show"
      :express-list="fillLogisticsInfo.expressList"
      @confrimHandler="confrimSubmit"
      @cancelHandler="cancelSubmit"
    ></fill-logistics-info>
    <look-logistics-info
      :show="lookLogisticsInfo.show"
      :express-info="lookLogisticsInfo.expressInfo"
      @closeLookLogisticsInfo="closeLookLogisticsInfo"
    ></look-logistics-info>
  </div>
</template>

<script>
import { List } from 'vant'
import Dialogs from '../Dialog'
import FillLogisticsInfo from './fillLogisticsInfo'
import LookLogisticsInfo from './lookLogisticsInfo'
import NoData from './NoData'
let flag = false
export default {
  name: 'inHandOrder',
  components: {
    List,
    Dialogs,
    FillLogisticsInfo,
    LookLogisticsInfo,
    NoData
  },
  data () {
    return {
      dialog: {
        show: false,
        cancelText: '再想想'
      },
      fillLogisticsInfo: {
        show: false,
        expressList: []
      },
      lookLogisticsInfo: {
        show: false,
        expressInfo: {}
      },
      loading: false,
      finished: false,
      pageNum: 1,
      orderList: [],
      refId: '',
      noData: false
    }
  },
  computed: {
    statusText (status) {
      return (status) => {
        switch (status) {
          case 10 :
            return '待审核'
          case 20:
            return '审核不通过'
          case 30:
            return '待寄回'
          case 31:
            return '上门取件'
          case 40:
            return '已寄送'
          case 50:
            return '商家已收货'
          case 60:
            return '退款成功'
          case 61:
            return '退款成功'
          case 70 :
            return '已取消'
          case 90:
            return '完成'
          default:
            return '审核中'
        }
      }
    }
  },
  created () {
    this.$toast.loading('加载中....')
    this.getOrderList(this.pageNum).then(() => {
      this.$toast.clear()
    })
  },
  methods: {

    /**
     * 分页加载
    */
    onLoad () {
      if (flag) {
        return false
      }
      flag = true
      setTimeout(() => {
        this.getOrderList(++this.pageNum).then(() => {
          this.loading = false
          flag = false
        })
      }, 500)
    },

    /**
     * 获取处理中列表
    */
    async getOrderList (pageNum) {
      const res = await this.$axios.get(`api/refund/list/102/${pageNum}`)
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.orderList = [...this.orderList, ...data]
        } else if (code === 9006) {
          if (pageNum === 1) {
            this.noData = true
          }
          this.finished = true
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 取消售后确认
    */
    async confrimHandler () {
      const res = await this.withdrawApplicationHandler(this.refId)
      if (res) {
        this.dialog.show = false
        this.orderList = this.orderList.filter(
          v => v['serial_no'] !== this.refId
        )
        if (!this.orderList.length) {
          this.noData = true
        }
      }
    },

    /**
     * 关闭弹窗
    */
    cancelHandler () {
      this.dialog.show = false
    },

    /**
     * 填写回寄物流信息
    */
    async confrimSubmit (expressInfo) {
      if (flag) {
        return
      }
      flag = true
      this.submitLogisticsInfoHandler(expressInfo).then(() => {
        flag = false
        this.fillLogisticsInfo.show = false
        this.orderList.map(v => {
          if (v['serial_no'] === this.refId) {
            v.status = 40
          }
          return v
        })
      })
    },

    /**
     * 取消
    */
    cancelSubmit (status) {
      this.fillLogisticsInfo.show = status
    },

    /**
     * 填写物流信息
     */
    async fillLogisticsInfoHandler (id) {
      this.refId = id
      await this.getExparessList(id)
      this.fillLogisticsInfo.show = true
    },

    /**
     * 获取快递公司列表
     */
    async getExparessList (id) {
      this.$toast.loading('请稍后...')
      const res = await this.$axios.get(`api/refund/exp-list/${id}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          this.fillLogisticsInfo.expressList = data
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 提交物流信息
     */
    async submitLogisticsInfoHandler ({ expressName, expressNumber }) {
      this.$toast.loading('正在提交,请稍后...')
      const res = await this.$axios.post('api/refund/bind-exp', {
        serial_no: this.refId,
        company: expressName,
        express_no: expressNumber
      })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg } = res.data
        if (code === 0) {
          this.$toast('提交成功')
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 查看物流信息
     */
    async lookLogisticsInfoHandler (id) {
      this.refId = id
      await this.getExpressInfoHandler()
      this.lookLogisticsInfo.show = true
    },

    /**
     * 关闭物流信息弹窗
     */
    closeLookLogisticsInfo () {
      this.lookLogisticsInfo.show = false
    },

    /**
     * 查看寄回信息
    */
    async getExpressInfoHandler () {
      const res = await this.$axios.post('?r=refund/refund-web/my-express', {
        serial_no: this.refId
      })
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          this.lookLogisticsInfo.expressInfo = data.data
        } else {
          this.$toast(msg)
        }
      }
    },
    withdrawApplication (refId) {
      this.dialog.show = true
      this.refId = refId
    },

    /**
     *取消售后
    */
    async withdrawApplicationHandler (refId) {
      this.$toast.loading('请稍后...')
      const res = await this.$axios.post('api/refund/cancel', {
        serial_no: refId
      })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg } = res.data
        if (code === 0) {
          this.$toast('取消成功')
          return true
        } else {
          this.$toast(msg)
          return false
        }
      }
    },

    /**
     * 查看服务单
    */
    async goDetails (refId) {
      // await this.getRefIdHandler({ refId })
      this.$router.push({ name: 'serviceSheetDetails', query: { refId } })
    },
    jumpDetails (goodsid, skuid, platform) {
      this.$router.push({
        name: 'productDetails',
        query: { goodsid, skuid, platform }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.order-list {
  padding: 0 0.2rem 0.3rem;
  background-color: #fff;
}
.sku-details {
  padding: 0.38rem 0 0.16rem;
  border-bottom: 0.5px solid #dadada;
  .service-ticket {
    font-size: @fz24;
    color: @base;
    padding-bottom: 0.26rem;
    .flex-between;
    .service-number {
      width: 5rem;
      .ellipsis;
    }
    .service-status {
      color: #ff9600;
      font-weight: 660;
    }
  }
  .jump-details {
    display: flex;
    justify-content: space-between;
  }
  .sku-img {
    width: 2rem;
    height: 2rem;
  }
  .sku-desc {
    padding-right: 0.33rem;
    width: 4.5rem;
  }
  .sku-intro {
    height: 2rem;
    .flex-column-between;
    margin-left: 0.2rem;
    .sku-title {
      width: 3.03rem;
      .ellipsis2;
      font-size: @fz24;
      color: @base;
    }
    .sku-name-num {
      .flex-between;
      .sku-name {
        max-width: 3.03rem;
        font-size: @fz20;
        color: @sku-name;
        background-color: #f5f5f5;
        border: 0.5px solid #cbcbcb;
        border-radius: 0.04rem;
        .ellipsis;
        span {
          padding: 0.05rem 0.1rem;
        }
      }
      .sku-num {
        font-size: @fz24;
        color: @base;
      }
    }
    .sku-platform {
      font-size: @fz24;
      color: @c80;
    }
  }
  .sku-functional-btn {
    margin-top: 0.21rem;
    height: 0.68rem;
    text-align: right;
    button {
      width: 1.7rem;
      height: 0.68rem;
      // border: 0.5px solid #979797;
      // border-radius: 30px;
      .hairline-surround(@color: #979797);
      color: @base;
      font-size: @fz24;
    }
  }
  .status-tips {
    position: relative;
    padding-left: 0.5rem;
    padding-right: 0.25rem;
    width: 5.8rem;
    height: 0.44rem;
    margin: 0.11rem auto 0;
    background-color: #ffecbb;
    .flex-between;
    font-size: @fz20;
    color: #8b572a;
    border-radius: 30px;
    button {
      color: #0076ff;
    }
    &::after {
      content: "";
      position: absolute;
      left: 0.1rem;
      top: 50%;
      transform: translateY(-50%);
      width: 0.32rem;
      height: 0.32rem;
      background: url("../../assets/img/mark.png") center no-repeat;
      background-size: 100%;
    }
  }
}
</style>
